import { useCalculatorStore } from '@src/stores';

/**
 * Hydrate the calculator store from backend calculatorDetails.
 * Ensures consistent null/empty fallbacks and ownership detection.
 *
 * @param {object|null|undefined} calculatorDetails
 * @param {string|undefined|null} socketId - current peer socket id
 */
export const hydrateSharedCalculator = (calculatorDetails, socketId) => {
  const calculatorStore = useCalculatorStore.getState();

  if (!calculatorDetails) {
    calculatorStore.resetSharedCalculatorData();
    return;
  }

  const { owner, settings, currentOperation } = calculatorDetails;
  const isSharedByMe = owner?.peer_id === socketId;

  calculatorStore.setSharedCalculatorData({
    isOpen: true,
    isSharedByMe,
    owner: owner ?? null,
    settings: settings ?? null,
  });

  calculatorStore.setSharedCalculatorState({
    expression: currentOperation?.expression ?? '',
    result: currentOperation?.result ?? '',
  });
};
